export default __webpack_public_path__ + "assets/6627c34296dcc7ff094f7b1e8ef6ce8a.jpg";